import React, { useEffect, useState } from 'react'
import Button from 'components/Button/Button'
import Divider from 'components/Divider'
import { Input } from 'components/Input'
import TextArea from 'components/TextArea/TextArea'
import { useAppDispatch, useAppState } from 'store'
import { clientActions } from 'store/slices/clients/clients.slice'
import { themes } from 'theme/styled'
import {
  ClientSettingsContainer,
  ClientSettingsItem,
  ClientSettingsRowContainer,
} from './ClientSettings.styled'
import Spinner from 'components/Spinner'
import toast from 'cogo-toast'

import { authActions } from 'store/slices/auth'
import { useParams } from 'react-router'

const ClientSettings = () => {
  const dispatch = useAppDispatch()
  const params = useParams<{ locationId: string; clientId: string }>()
  const { currentClient, loading } = useAppState(state => state.clients)
  const { authStatus } = useAppState(state => state.auth)
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [address, setAddress] = useState<string>('')
  const [secondaryAddress, setSecondaryAddress] = useState<string>('')
  const [zipCode, setZipCode] = useState<string>('')
  const [city, setCity] = useState<string>('')
  const [state, setState] = useState<string>('')
  const [notes, setNotes] = useState<string>('')

  useEffect(() => {
    if (currentClient) {
      setFirstName(currentClient.name)
      setLastName(currentClient.last_name)
      setEmail(currentClient.email)
      setPhone(currentClient.phone ? currentClient.phone : '')
      setAddress(currentClient.address ? currentClient.address : '')
      setSecondaryAddress(
        currentClient.secondary_address ? currentClient.secondary_address : ''
      )
      setZipCode(currentClient.zipcode ? currentClient.zipcode : '')
      setCity(currentClient.city ? currentClient.city : '')
      setState(currentClient.state ? currentClient.state : '')
    }
  }, [currentClient])

  const handleSubmit = async () => {
    if (currentClient) {
      await dispatch(
        clientActions.updateClientById({
          clientId: currentClient.id,
          name: firstName,
          last_name: lastName,
          secondary_address: secondaryAddress,
          zipcode: zipCode,
          email,
          phone,
          address,
          city,
          state,
          notes,
        })
      ).then((data: any) => {
        if (!data.payload.error) {
          toast.success('User profile successfully updated', {
            position: 'top-right',
          })
        }
      })
    }
  }
  const resetPassword = async () => {
    await dispatch(
      authActions.resetPassword({
        locationId: params.locationId,
        userId: params.clientId,
      })
    )
  }

  return (
    <ClientSettingsContainer>
      {loading === 'loading' ? (
        <Spinner />
      ) : (
        <>
          <ClientSettingsRowContainer>
            <ClientSettingsItem>
              <Input
                label={'First Name'}
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
              />
            </ClientSettingsItem>
            <ClientSettingsItem>
              <Input
                label={'Last Name'}
                value={lastName}
                onChange={e => setLastName(e.target.value)}
              />
            </ClientSettingsItem>
          </ClientSettingsRowContainer>
          <ClientSettingsRowContainer>
            <ClientSettingsItem>
              <Input
                label={'Email'}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </ClientSettingsItem>
            <ClientSettingsItem>
              <Input
                label={'Phone'}
                value={phone}
                format="(###) ###-####"
                mask="_"
                onChange={e => setPhone(e.target.value)}
              />
            </ClientSettingsItem>
          </ClientSettingsRowContainer>
          <ClientSettingsRowContainer>
            <ClientSettingsItem>
              <Input
                label={'Address line 1'}
                value={address}
                onChange={e => setAddress(e.target.value)}
              />
            </ClientSettingsItem>
            <ClientSettingsItem>
              <Input
                label={'Address line 2'}
                value={secondaryAddress}
                onChange={e => setSecondaryAddress(e.target.value)}
              />
            </ClientSettingsItem>
          </ClientSettingsRowContainer>
          <ClientSettingsRowContainer>
            <ClientSettingsItem>
              <Input
                label={'City'}
                value={city}
                onChange={e => setCity(e.target.value)}
              />
            </ClientSettingsItem>
            <ClientSettingsItem>
              <Input
                label={'State'}
                value={state}
                onChange={e => setState(e.target.value)}
              />
            </ClientSettingsItem>
          </ClientSettingsRowContainer>
          <ClientSettingsRowContainer>
            <ClientSettingsItem>
              <Input
                label={'Zip Code'}
                format="#####"
                mask="_"
                value={zipCode}
                onChange={e => setZipCode(e.target.value)}
              />
            </ClientSettingsItem>
            <ClientSettingsItem></ClientSettingsItem>
          </ClientSettingsRowContainer>
          <Divider
            color={themes.Light.colors.borderSecondary}
            style={{ marginTop: 20, marginBottom: 20 }}
          />

          <ClientSettingsRowContainer style={{ marginBottom: 15 }}>
            <ClientSettingsItem>
              <TextArea
                label={'Notes'}
                size={96}
                required={false}
                value={notes}
                onTextChange={e => setNotes(e)}
              />
            </ClientSettingsItem>
          </ClientSettingsRowContainer>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}>
            <Button
              text="Update"
              variant="primary"
              preset="filled"
              size={'medium'}
              disabled={authStatus === 'loading' ? true : false}
              loading={authStatus === 'loading' ? true : false}
              onClick={handleSubmit}
            />
            <Button
              text="Reset Password"
              variant="secondary"
              preset="ghost"
              size={'medium'}
              disabled={authStatus === 'loading' ? true : false}
              loading={authStatus === 'loading' ? true : false}
              onClick={resetPassword}
            />
          </div>
        </>
      )}
    </ClientSettingsContainer>
  )
}

export default ClientSettings
